export const SOURCE = 'growth-profile-page'
